import React, {Fragment} from "react";
import {useSelector} from "react-redux";
import DeleteModal from "../../../components/Modal/DeleteModal";
import AlertForm from "../../../components/Modal/components/AlertForm";
import ListView from "../../../components/ContentDisplay/ListView";
import AlertsCard, {CustomRenderComponent} from "../../Alerts/alertsTable/alertsCard";
import {useAlertSearchOptions} from "../../Alerts/alertsTable/useAlertSearchOptions";
import AlertHandoff from "../../../components/Modal/AlertHandoff";
import {useSensorAlertTableActions} from "./useSensorAlertTableActions";
import {useSensorAlertTableData} from "./useSensorAlertTableData";
import {getUserProfile} from "../../../redux/Selectors/users.selector";
import {
  getListHeaders,
  ACTIONS_LIST,
  CUSTOM_RENDER_KEYS,
} from "./sensorAlertsTable.constants";

const SensorAlertsTable = () => {
  const {searchOptions} = useAlertSearchOptions("sensor");
  const userProfile = useSelector(getUserProfile);
  const isStaffOrSuperuser = Boolean(userProfile?.is_staff || userProfile?.is_superuser);
  const {
    alertTotalCount,
    fetchAfterDelete,
    handleSearch,
    paginationConfig,
    sensorAlertsList,
  } = useSensorAlertTableData();
  const {
    closeDeleteModal,
    closeEditModal,
    closeHandoffModal,
    handleActionSelection,
    handleDelete,
    handleToggle,
    isDeleteModalOpen,
    isEditModalOpen,
    isHandoffModalOpen,
    selectedRow,
  } = useSensorAlertTableActions(fetchAfterDelete);

  return (
    <Fragment>
      {isDeleteModalOpen && (
        <DeleteModal
          header={"Delete Alert"}
          modalBody={"Are you sure you want to delete this alert ?"}
          onClose={closeDeleteModal}
          onDelete={handleDelete}
          open={isDeleteModalOpen}
        />
      )}
      {isHandoffModalOpen && (
        <AlertHandoff
          open={isHandoffModalOpen}
          onCancel={closeHandoffModal}
          alertId={selectedRow.id}
          type="sensor"
        />
      )}
      {isEditModalOpen && (
        <AlertForm
          closeAlertForm={closeEditModal}
          data={selectedRow}
          metricType={"sensor-downtime"}
          showAlertForm={isEditModalOpen}
        />
      )}
      <div className="table-container">
        <ListView
          listItems={sensorAlertsList}
          listHeaders={getListHeaders(isStaffOrSuperuser)}
          onSelectAction={handleActionSelection}
          withActions
          actionsList={ACTIONS_LIST}
          permsForActions={[]}
          totalCount={alertTotalCount}
          withPagination={paginationConfig}
          booleanAsToggle
          onClickToggle={handleToggle}
          withSearchQuery={true}
          searchPlaceHolder={"Filter Alerts"}
          searchOptions={searchOptions}
          handleSearch={handleSearch}
          cardContent={(props) => (
            <AlertsCard
              {...props}
              alertType="sensor"
              isStaffOrSuperuser={isStaffOrSuperuser}
            />
          )}
          customRenderKeys={CUSTOM_RENDER_KEYS}
          customRenderComponent={(props) => (
            <CustomRenderComponent {...props} alertType="sensor" />
          )}
        />
      </div>
    </Fragment>
  );
};

export default SensorAlertsTable;
